import { fillPrefixedAddressLookupValues, getLookupByMurn } from "@modernary/mui/components/lookup";
import type { Organization, OrganizationNew } from "./organization";
import { murnAddressFromFormkit, murnAddressToFormkit } from "@modernary/mui/components/fk";

export default {
  addAuthRequestFields,
  getInitialData,
  skinnyResponseAdapter,
  responseAdapter,
  requestAdapter,
  fromFormkit,
  toFormkit,
};

function addAuthRequestFields(entity: Organization) {
  entity._authRequestFields = ["id"];
  return entity;
}
function getInitialData() {
  const result = {} as Organization; //TODO: ts
  return addAuthRequestFields(result);
}

/** Be sure to await this when using it. Commonly used for lists and child lists */
async function skinnyResponseAdapter(response: { data: Organization }) {
  await fillPrefixedAddressLookupValues(response.data, ["mail"]);
  addAuthRequestFields(response.data);

  return response.data as Organization;
}

/** Be sure to await this when using it. */
async function responseAdapter(response: { data: Organization }) {
  await skinnyResponseAdapter(response);

  return response.data;
}

function requestAdapter(data: Organization) {
  return data;
}

// Convert server data for use in the page's form (which may have groupings, etc different from the server data)
function toFormkit<T extends Organization | OrganizationNew>(data: T) {
  murnAddressToFormkit(data, "mail");
  //TODO: Mask Bug phoneNumber only set to be undefined to fix formkit bug. Once formkit resolves bug remove
  if (!data.phoneNumber) {
    data.phoneNumber = undefined;
  }
  //TODO: Mask Bug faxNumber only set to be undefined to fix formkit bug. Once formkit resolves bug remove
  if (!data.faxNumber) {
    data.faxNumber = undefined;
  }
}

// Convert formkit data to prep it for sending to the server (which is probably flatter than the fk data)
function fromFormkit(data: Organization) {
  murnAddressFromFormkit(data as Organization, "mail");
  //TODO: Mask Bug remove this once the if above is removed.
  if (data.phoneNumber === undefined) {
    data.phoneNumber = null;
  }
  //TODO: Mask Bug remove this once the if above is removed.
  if (data.faxNumber === undefined) {
    data.faxNumber = null;
  }
}
